import { RunningExperiments, useExperiments } from 'state/experiments';

export const useEnableStoreLocatorNewUIABTest = () => {
  const { variant } = useExperiments();

  return variant(RunningExperiments.StoreLocatorNewUIABTest, 'treatment');
};
